<template>
  <div class="main scroll">
    <div class="scroll-wrapper">
      <div class="table" >
          <a-table :loading="spinning"  rowKey='id' :pagination="false" :dataSource="table" :columns="column">
          <template slot="head_img"  slot-scope="text, record">
            <span>
              <a-avatar shape="square" :size="60" :src="record.head_img" />
            </span>
          </template>
          <template slot="actions"  slot-scope="text, record">
              <a-button size="small" style="background-color: #67b0dc;border: none;" @click="look(record)" type="primary" shape="round" icon="edit">查看</a-button>
            </template>
        </a-table>
      </div>
    </div>
    <a-modal
      :title="'成长册列表-' + name"
      :visible="visible"
      :footer="false"
      width="86%"
      @cancel="visible = false"
    >
      <a-spin style="min-height: 200px;" :spinning="spinning"><div style="padding: 0 25px;"><a-alert message="点击黑色阴影处也可关闭弹窗" type="info" /></div> <pc-growup v-if="visible"  :guc_id="guc_id" :sid="sid"></pc-growup></a-spin>
    </a-modal>
    <div v-if="!is_complete" @click="submitModal = true" class="fixed">
      <a-icon type="vertical-align-top" /> 提交成长册
    </div>

    <a-modal :visible="submitModal" centered :closable="false" footer="">
          <div class="modal3 red">
           
            <img :src="require('../assets/log2.png')" alt="" />
            <div class="msg">
              <div class="title">已经确认所有成长册修改完毕？</div>
              <div class="btns">
                <a-button @click="submitModal = false">取消</a-button>
                <a-button @click="submit" type="danger">
                  确认提交
                </a-button>
              </div>
            </div>
          </div>
        </a-modal>
  </div>
</template>

<script>
import {api} from '@/api/api.js';
import { mapState } from 'vuex';
import pcGrowup from './pcGrowup.vue';
export default {
  data() {
    return {
      column:[
          {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
            width: '200px',
            scopedSlots: { customRender: "name" },
          },
          // {
          //   title: '头像',
          //   dataIndex: 'head_img',
          //   key: 'head_img',
          //   scopedSlots: { customRender: "head_img" },
          // },
          {
            title: '进度',
            dataIndex: 'progress',
            key: 'progress',
            width: '250px',
            scopedSlots: { customRender: "progress" },
          },{
            title: '操作',
            dataIndex: 'actions',
            key: 'actions',
            scopedSlots: { customRender: "actions" },
          }],
      table:[],
      spinning:false,
      visible:false,
      guc_id:'',
      sid:'',
      submitModal:false,
      is_complete:false,
      name:''
    };
  },
  components:{
    pcGrowup
  },
  computed: {
    ...mapState(['headers'])
  },
  created() {
    console.log(this.headers)
    if (this.headers) {
      this.getPross()
    }
  },
  watch: {
    headers(val) {
      if (cal) {
        this.getPross() 
      }
    }
  },
  methods: {
    getDetail() {
      this.$axios({
          method: "GET",
          url: this.$api.domain + this.$api.growupDetail,
          headers: { Authorization: this.headers },
          params: {
            guc_id: this.table[0].guc_id,
            s_id: this.table[0].id,
          },
        })
          .then((res) => {
            if (res.data.status == 200 && res.data.data) {
              this.is_complete = res.data.data.info.is_complete ? true : false;
            }
          })
          .catch((res) => {
            // this.$message.error(res.data.msg);
          });
    },
    look(record) {
      this.spinning = true
      this.guc_id = record.guc_id
      this.sid = record.id
      this.visible = true
      this.name = record.name
      setTimeout(() => {
        this.spinning = false
      }, 1500);
    },
    submit() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.submitGrowup,
        headers: { Authorization: this.$store.state.headers },
        data: {
          gu_id: this.table[0].gu_id,
          is_complete: 1,
        },
      })
        .then((res) => {
          if (res.data.msg == '操作失败') {
            this.$message.error('提交失败，请勿重复提交');
          } else {
            this.$message.success('提交成功');
          }
          
          this.submitModal = false;
          if (res.data.status == 200) {
            this.is_complete = true;
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getPross() {
      this.spinning = true
      this.$axios({
        method: "POST",
        url: api.domain + api.getPross,
        headers: { Authorization: this.$store.state.headers },
        data: {
          limit: 200,
          page: 1,
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            console.log(res)
            this.table = res.data.data.data
            if (this.table.length > 0) {
              this.getDetail()
            }
            setTimeout(() => {
              this.spinning = false
            }, 1000);
          }
        })
        .catch((res) => {
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .main{
    margin-top: 20px;
  }

  .fixed{
    position: fixed;
    right: 30px;
    bottom: 30px;
    padding: 10px 20px;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    background: #d18c53;
    cursor: pointer;
  }
</style>
